import type {BlobLayoutStyledBlobPayload} from '@github-ui/code-view-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isUIService} from '@github-ui/runtime-environment'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {useCodeViewOptions} from '@github-ui/use-code-view-options'
import {useSearchParams} from '@github-ui/use-navigate'

import {useCurrentBlame} from './CurrentBlame'
import {useCurrentStyledBlob} from './CurrentStyledBlob'
import {BlobDisplayType, useBlobRendererType} from './use-blob-renderer-type'

export function useShouldUseTaillights(resolvedSource?: BlobLayoutStyledBlobPayload) {
  const {codeWrappingOption} = useCodeViewOptions()
  const {isBrowser} = useRuntimeEnvironment()
  const hasBlame = !!useCurrentBlame()
  const displayType = useBlobRendererType()
  const currentSource = useCurrentStyledBlob()
  const {rawLines, stylingDirectives} = resolvedSource ?? currentSource
  const [params] = useSearchParams()
  return (
    isFeatureEnabled('code_view_enable_taillights') &&
    (!isBrowser || !codeWrappingOption.enabled) &&
    !hasBlame &&
    displayType === BlobDisplayType.Code &&
    rawLines != null &&
    stylingDirectives != null &&
    params.get('h') !== '1'
  )
}

export function useShouldResolveTaillightsSource() {
  const hasBlame = !!useCurrentBlame()
  const displayType = useBlobRendererType()
  return (
    isUIService && isFeatureEnabled('code_view_enable_taillights') && !hasBlame && displayType === BlobDisplayType.Code
  )
}
